var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 60,
    viewBox: "0 0 119 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_6445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6622 11.7341C48.6622 11.7341 46.6351 11.5542 45.0551 16.0849C44.4115 17.9339 43.5677 19.705 42.646 21.2572C40.3853 22.5962 38.3342 21.719 36.7578 20.3448C37.4792 20.1463 38.4288 19.7995 39.4432 19.1931C41.6075 17.9005 42.939 14.4436 44.5692 12.5186C46.1696 10.6232 48.5787 11.6952 48.6584 11.7322C48.6603 11.7341 48.6622 11.7341 48.6622 11.7341Z",
    fill: "url(#paint0_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6575 11.7321C48.5778 11.695 46.1687 10.6231 44.5683 12.5184C42.9381 14.4453 41.6084 17.9022 39.4423 19.1929C38.4278 19.7994 37.4783 20.1462 36.7569 20.3446C35.5774 19.3153 34.665 18.0097 34.1309 17.1437C36.6048 18.7998 38.0588 17.446 40.0172 14.3563C42.4912 10.4543 45.0523 8.48664 48.6575 11.7321Z",
    fill: "url(#paint1_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M48.6575 11.7321C48.5778 11.695 46.1687 10.6231 44.5683 12.5184C42.9381 14.4453 41.6084 17.9022 39.4423 19.1929C38.4278 19.7994 37.4783 20.1462 36.7569 20.3446C35.5774 19.3153 34.665 18.0097 34.1309 17.1437C36.6048 18.7998 38.0588 17.446 40.0172 14.3563C42.4912 10.4543 45.0523 8.48664 48.6575 11.7321Z",
    fill: "url(#paint2_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6455 21.257C41.3084 23.5103 39.8062 25.3018 38.508 26.1864C37.0689 27.1693 33.8494 29.3744 29.6192 23.4435C25.4539 17.6073 16.9526 9.59561 11.5596 18.5123C11.5596 18.5123 11.5596 18.5049 11.5596 18.4882C11.5577 17.9819 11.6393 10.0222 18.5939 8.72398C23.0634 7.83008 28.0094 10.9884 31.9429 15.1908C32.7608 16.0661 33.4822 16.7097 34.1332 17.1436C34.6654 18.0097 35.5797 19.3153 36.7592 20.3446C38.3337 21.7206 40.3848 22.5978 42.6455 21.257Z",
    fill: "url(#paint3_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4759 19.2485L39.4092 19.1372C40.7723 18.3231 41.8015 16.6429 42.7974 15.0183C43.3761 14.0743 43.9213 13.1823 44.5185 12.4775L44.6186 12.561C44.0289 13.2583 43.4855 14.1466 42.9087 15.0869C41.9054 16.7245 40.8669 18.4195 39.4759 19.2485Z",
    fill: "url(#paint4_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5596 18.4884C11.5596 18.4884 12.3552 13.4922 14.6288 11.3169C16.6614 9.3733 20.99 6.28362 26.5499 11.4059C31.8928 16.3279 35.2514 23.8332 40.2587 22.5814C40.2587 22.5814 36.8612 26.6336 33.5545 22.8503C30.2479 19.067 26.0714 13.5516 22.3178 12.1514C18.5642 10.7512 13.1378 13.9188 11.5596 18.4884Z",
    fill: "url(#paint5_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5522 22.8478C33.1164 22.3619 32.6843 21.8742 32.2541 21.3846L30.9744 19.9065C30.1195 18.9217 29.2645 17.9388 28.3725 16.9893C27.486 16.0361 26.5662 15.1125 25.5777 14.2668L25.2068 13.9497C25.0807 13.8458 24.949 13.7513 24.821 13.6511L24.4334 13.3544L24.0291 13.0818C23.4969 12.7071 22.9164 12.4086 22.3174 12.1489C23.5451 12.6033 24.6356 13.3599 25.6407 14.1889C26.6478 15.0235 27.5713 15.9508 28.4671 16.9003C29.3535 17.8572 30.2103 18.842 31.0505 19.8416L33.5522 22.8478Z",
    fill: "url(#paint6_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2214 12.5961C37.6898 12.5961 39.6909 10.5951 39.6909 8.12669C39.6909 5.65827 37.6898 3.65723 35.2214 3.65723C32.753 3.65723 30.752 5.65827 30.752 8.12669C30.752 10.5951 32.753 12.5961 35.2214 12.5961Z",
    fill: "url(#paint7_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5786 52.5412C35.5786 52.5412 36.8063 50.9184 33.8057 47.176C32.5817 45.6497 31.5283 43.9954 30.7012 42.3875C30.7661 39.7615 32.5984 38.4874 34.5994 37.8828C34.3843 38.6005 34.1747 39.589 34.1506 40.7703C34.0968 43.2907 36.3186 46.2542 37.0864 48.6577C37.843 51.0204 35.6547 52.4929 35.5823 52.5412C35.5805 52.5393 35.5786 52.5412 35.5786 52.5412Z",
    fill: "url(#paint8_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5822 52.5393C35.6563 52.4911 37.8428 51.0186 37.0862 48.6559C36.3184 46.2524 34.0948 43.2888 34.1504 40.7685C34.1745 39.5872 34.386 38.5987 34.5992 37.881C36.0977 37.4285 37.6889 37.3469 38.7052 37.3561C35.9883 38.5727 36.3629 40.5237 37.943 43.8248C39.9385 47.992 40.2463 51.2078 35.5822 52.5393Z",
    fill: "url(#paint9_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M35.5822 52.5393C35.6563 52.4911 37.8428 51.0186 37.0862 48.6559C36.3184 46.2524 34.0948 43.2888 34.1504 40.7685C34.1745 39.5872 34.386 38.5987 34.5992 37.881C36.0977 37.4285 37.6889 37.3469 38.7052 37.3561C35.9883 38.5727 36.3629 40.5237 37.943 43.8248C39.9385 47.992 40.2463 51.2078 35.5822 52.5393Z",
    fill: "url(#paint10_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7007 42.3876C29.5008 40.0583 28.7812 37.8347 28.7181 36.2658C28.6495 34.5244 28.4882 30.6261 35.7617 30.1884C42.9184 29.7563 54.22 26.8057 49.528 17.5015C49.528 17.5015 49.5354 17.5052 49.5484 17.5144C49.9787 17.7815 56.681 22.0748 54.0902 28.6584C52.4749 32.9202 47.1728 35.4349 41.5238 36.5384C40.348 36.7684 39.4207 37.0373 38.7067 37.3581C37.6904 37.3507 36.0992 37.4304 34.6008 37.8829C32.5979 38.4875 30.7656 39.7598 30.7007 42.3876Z",
    fill: "url(#paint11_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0264 48.6763C36.7482 47.8066 36.2846 46.8737 35.7931 45.8871C34.9363 44.1661 34.0517 42.3876 34.087 40.7686L34.2168 40.7723C34.1815 42.3598 35.0606 44.1234 35.91 45.8296C36.4033 46.8218 36.8688 47.7583 37.1507 48.6374L37.0264 48.6763Z",
    fill: "url(#paint12_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5479 17.5122C49.5479 17.5122 53.3608 20.8374 53.9969 23.9215C54.5644 26.6755 54.8853 31.9832 47.5932 33.9769C40.5849 35.8908 32.4434 34.7558 30.8466 39.6629C30.8466 39.6629 29.2146 34.6334 34.1793 33.8378C39.1439 33.0422 46.0298 32.4339 49.2104 29.9952C52.3891 27.5546 52.5838 21.2751 49.5479 17.5122Z",
    fill: "url(#paint13_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1797 33.8364C34.8214 33.7251 35.4649 33.6175 36.1084 33.5137L38.0409 33.2132C39.3279 33.0111 40.6168 32.809 41.8946 32.5567C43.1742 32.3119 44.4446 32.0208 45.6853 31.6332L46.1508 31.4867C46.3047 31.4347 46.4568 31.3754 46.6089 31.3198L47.0651 31.1491L47.5102 30.9507C48.1111 30.6985 48.673 30.3647 49.2089 29.9956C48.1723 30.7931 46.952 31.3179 45.715 31.7296C44.4743 32.1395 43.1984 32.4306 41.9187 32.6847C40.6354 32.9276 39.3465 33.1316 38.0557 33.3134L34.1797 33.8364Z",
    fill: "url(#paint14_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7683 47.5336C48.2367 47.5336 50.2378 45.5326 50.2378 43.0642C50.2378 40.5958 48.2367 38.5947 45.7683 38.5947C43.2999 38.5947 41.2988 40.5958 41.2988 43.0642C41.2988 45.5326 43.2999 47.5336 45.7683 47.5336Z",
    fill: "url(#paint15_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84668 21.3828C6.84668 21.3828 7.68123 23.2374 12.4066 22.3991C14.3335 22.056 16.29 21.9262 18.0964 21.9707C20.37 23.2856 20.6093 25.5055 20.1809 27.551C19.6542 27.0188 18.8864 26.3604 17.8627 25.7725C15.6762 24.5151 12.0116 25.0455 9.53392 24.5671C7.09704 24.0997 6.8541 21.4755 6.84668 21.3865C6.84668 21.3847 6.84668 21.3828 6.84668 21.3828Z",
    fill: "url(#paint16_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84677 21.3862C6.85419 21.4734 7.09714 24.0994 9.53402 24.5686C12.0117 25.0471 15.6781 24.5186 17.8628 25.7741C18.8865 26.362 19.6543 27.0203 20.181 27.5526C19.8601 29.0845 19.1684 30.5199 18.6732 31.4082C18.9088 28.4409 17.0171 27.8345 13.3618 27.6379C8.74769 27.3913 5.77855 26.119 6.84677 21.3862Z",
    fill: "url(#paint17_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M6.84677 21.3862C6.85419 21.4734 7.09714 24.0994 9.53402 24.5686C12.0117 25.0471 15.6781 24.5186 17.8628 25.7741C18.8865 26.362 19.6543 27.0203 20.181 27.5526C19.8601 29.0845 19.1684 30.5199 18.6732 31.4082C18.9088 28.4409 17.0171 27.8345 13.3618 27.6379C8.74769 27.3913 5.77855 26.119 6.84677 21.3862Z",
    fill: "url(#paint18_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0968 21.9727C20.7173 22.0376 23.0132 22.4715 24.419 23.1688C25.9805 23.944 29.4782 25.6725 26.3755 32.2635C23.3229 38.7508 20.4929 50.0839 30.908 50.427C30.908 50.427 30.9006 50.4307 30.8858 50.44C30.4463 50.6903 23.4639 54.5126 18.9295 49.0806C15.9641 45.62 16.2998 39.7596 18.0393 34.2739C18.401 33.1315 18.6105 32.1894 18.6717 31.4086C19.1669 30.5203 19.8586 29.0848 20.1795 27.553C20.6097 25.5074 20.3705 23.2875 18.0968 21.9727Z",
    fill: "url(#paint19_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8289 25.8319C16.4528 25.04 14.4833 24.9658 12.5787 24.8916C11.4715 24.849 10.4274 24.8082 9.52051 24.6338L9.54462 24.5059C10.4422 24.6802 11.4826 24.7191 12.5842 24.7618C14.5055 24.836 16.4899 24.912 17.8938 25.7187L17.8289 25.8319Z",
    fill: "url(#paint20_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8858 50.4401C30.8858 50.4401 26.14 52.1908 23.1282 51.2709C20.4391 50.4494 15.6266 48.185 17.3754 40.8298C19.0557 33.7621 23.9572 27.1618 20.4169 23.4082C20.4169 23.4082 25.6133 24.3893 23.9313 29.1258C22.2492 33.8623 19.4803 40.1974 20.0961 44.1569C20.7118 48.1163 26.1289 51.2969 30.8858 50.4401Z",
    fill: "url(#paint21_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9299 29.1235C23.7203 29.7411 23.5052 30.3568 23.2882 30.9707L22.6243 32.8104C22.1848 34.0381 21.7434 35.2639 21.3539 36.5065C20.9552 37.7453 20.601 39.0009 20.3469 40.2768L20.2523 40.7553C20.2245 40.9148 20.2041 41.0761 20.18 41.2374L20.1114 41.7196L20.0724 42.2055C20.0057 42.8528 20.0279 43.5056 20.0947 44.1546C19.8907 42.862 20.0168 41.5397 20.2486 40.2582C20.4841 38.973 20.8402 37.7138 21.2297 36.4675C21.6321 35.225 22.0698 33.9973 22.5316 32.777L23.9299 29.1235Z",
    fill: "url(#paint22_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2771 39.3403C12.7455 39.3403 14.7465 37.3392 14.7465 34.8708C14.7465 32.4024 12.7455 30.4014 10.2771 30.4014C7.80866 30.4014 5.80762 32.4024 5.80762 34.8708C5.80762 37.3392 7.80866 39.3403 10.2771 39.3403Z",
    fill: "url(#paint23_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3026 28.4545H63.966L62.7902 31.9262H57.7773L64.8914 12.2661H70.4365L77.5505 31.9262H72.4821L71.3026 28.4545ZM70.0711 24.7565L67.6343 17.559L65.2252 24.7565H70.0711Z",
    fill: "url(#paint24_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4347 12.266L77.5488 31.9261H72.4803L71.3045 28.4544H63.9661L62.7903 31.9261H57.7775L64.8915 12.266H70.4347ZM65.2253 24.7564H70.0694L67.6325 17.5589L65.2253 24.7564ZM70.7148 11.8691H70.4366H64.8915H64.6133L64.5187 12.1306L57.4028 31.7907L57.21 32.323H57.7756H62.7884H63.074L63.1649 32.054L64.2498 28.8512H71.0171L72.102 32.054L72.1929 32.323H72.4785H77.5469H78.1126L77.9197 31.7907L70.8094 12.1306L70.7148 11.8691ZM65.778 24.3595L67.6362 18.8033L69.5167 24.3595H65.778Z",
    fill: "url(#paint25_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4935 28.2301H94.5619V31.9262H79.7051V12.2661H84.4935V28.2301Z",
    fill: "url(#paint26_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4939 12.266V28.23H94.5623V31.9261H79.7055V12.266H84.4939ZM84.8908 11.8691H84.4939H79.7055H79.3086V12.266V31.9261V32.323H79.7055H94.5623H94.9591V31.9261V28.23V27.8331H94.5623H84.8908V12.266V11.8691Z",
    fill: "url(#paint27_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9757 22.0547H69.1521L70.0682 24.7549H65.2241L66.1292 22.0547H61.3481L57.7744 31.9283H62.7891L63.9649 28.4547H71.3033L72.4791 31.9283H77.5513L73.9757 22.0547Z",
    fill: "url(#paint28_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4943 28.2285V22.0547H79.7021V31.9283H94.5571V28.2266H84.4943V28.2285Z",
    fill: "url(#paint29_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.827 28.2301H111.895V31.9262H97.0381V12.2661H101.827V28.2301Z",
    fill: "url(#paint30_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.826 12.266V28.23H111.894V31.9261H97.0375V12.266H101.826ZM102.223 11.8691H101.826H97.0375H96.6406V12.266V31.9261V32.323H97.0375H111.894H112.291V31.9261V28.23V27.8331H111.894H102.223V12.266V11.8691Z",
    fill: "url(#paint31_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.827 28.2285V22.0547H97.0352V31.9283H111.89V28.2266H101.827V28.2285Z",
    fill: "url(#paint32_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8678 36.7194C57.2646 35.9998 57.8192 35.4397 58.5294 35.0373C59.2397 34.6349 60.0465 34.4346 60.9478 34.4346C62.0512 34.4346 62.9971 34.7257 63.7834 35.3081C64.5697 35.8904 65.0945 36.686 65.3597 37.693H62.8691C62.6836 37.3036 62.4203 37.0087 62.0809 36.8047C61.7415 36.6025 61.3539 36.5005 60.9218 36.5005C60.2245 36.5005 59.6589 36.7435 59.2268 37.2294C58.7946 37.7153 58.5777 38.3644 58.5777 39.1767C58.5777 39.9889 58.7946 40.638 59.2268 41.1239C59.6589 41.6098 60.2245 41.8528 60.9218 41.8528C61.3539 41.8528 61.7415 41.7508 62.0809 41.5486C62.4203 41.3446 62.6836 41.0497 62.8691 40.6603H65.3597C65.0945 41.6673 64.5697 42.4592 63.7834 43.0378C62.9971 43.6164 62.0531 43.9057 60.9478 43.9057C60.0465 43.9057 59.2416 43.7055 58.5294 43.303C57.8192 42.9006 57.2646 42.3424 56.8678 41.6284C56.4709 40.9125 56.2725 40.0965 56.2725 39.1785C56.2725 38.2568 56.4709 37.4389 56.8678 36.7194Z",
    fill: "url(#paint33_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9476 34.4329C62.051 34.4329 62.9969 34.7241 63.7832 35.3064C64.5695 35.8887 65.0944 36.6843 65.3596 37.6914H62.8689C62.6834 37.3019 62.4201 37.007 62.0807 36.803C61.7413 36.6009 61.3537 36.4989 60.9216 36.4989C60.2243 36.4989 59.6587 36.7418 59.2266 37.2277C58.7945 37.7136 58.5775 38.3627 58.5775 39.175C58.5775 39.9873 58.7945 40.6364 59.2266 41.1223C59.6587 41.6082 60.2243 41.8511 60.9216 41.8511C61.3537 41.8511 61.7413 41.7491 62.0807 41.547C62.4201 41.343 62.6834 41.0481 62.8689 40.6586H65.3596C65.0944 41.6657 64.5695 42.4575 63.7832 43.0362C62.9969 43.6148 62.0529 43.9041 60.9476 43.9041C60.0463 43.9041 59.2414 43.7038 58.5293 43.3014C57.819 42.8989 57.2645 42.3407 56.8676 41.6267C56.4707 40.9109 56.2723 40.0949 56.2723 39.1769C56.2723 38.2589 56.4707 37.4391 56.8676 36.7196C57.2645 36 57.819 35.4399 58.5293 35.0375C59.2414 34.6351 60.0463 34.4329 60.9476 34.4329ZM60.9476 34.2456C60.0185 34.2456 59.1728 34.457 58.4384 34.8724C57.7003 35.2897 57.1161 35.8795 56.7044 36.6268C56.2927 37.3705 56.085 38.2292 56.085 39.175C56.085 40.1208 56.2927 40.9776 56.7044 41.7176C57.1179 42.4613 57.7003 43.0491 58.4384 43.4646C59.1746 43.88 60.0185 44.0914 60.9476 44.0914C62.0881 44.0914 63.0785 43.7873 63.8945 43.1864C64.7123 42.5837 65.2668 41.7491 65.5413 40.705L65.6025 40.4695H65.3596H62.8689H62.7502L62.6983 40.577C62.5295 40.9294 62.2903 41.2002 61.9824 41.3838C61.6746 41.5674 61.3166 41.6619 60.9198 41.6619C60.2725 41.6619 59.7625 41.445 59.3638 40.9962C58.9651 40.5492 58.7629 39.9354 58.7629 39.1731C58.7629 38.4128 58.9651 37.7989 59.3638 37.3501C59.7625 36.9013 60.2725 36.6843 60.9198 36.6843C61.3166 36.6843 61.6727 36.7771 61.9824 36.9625C62.2884 37.1461 62.5295 37.4169 62.6964 37.7692L62.7484 37.8768H62.867H65.3577H65.6006L65.5395 37.6413C65.265 36.5972 64.7105 35.7608 63.8926 35.1543C63.0785 34.5535 62.0881 34.2456 60.9476 34.2456Z",
    fill: "url(#paint34_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0164 42.0904H71.9836V43.8392H66.752V34.5405H69.0164V42.0904Z",
    fill: "url(#paint35_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0162 34.5407V42.0906H71.9834V43.8394H66.7518V34.5407H69.0162ZM69.2035 34.3516H69.0162H66.7518H66.5645V34.5389V43.8376V44.0249H66.7518H71.9834H72.1708V43.8376V42.0887V41.9014H71.9834H69.2035V34.5389V34.3516Z",
    fill: "url(#paint36_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8582 42.1961H75.3883L74.8319 43.8392H72.46L75.8241 34.5405H78.4464L81.8106 43.8392H79.4127L78.8582 42.1961ZM78.2758 40.4473L77.1241 37.0423L75.9855 40.4473H78.2758Z",
    fill: "url(#paint37_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4479 34.5407L81.812 43.8394H79.4141L78.8577 42.1963H75.3879L74.8315 43.8394H72.4595L75.8237 34.5407H78.4479ZM75.9832 40.4475H78.2754L77.1237 37.0425L75.9832 40.4475ZM78.5795 34.3516H78.4479H75.8255H75.6939L75.6494 34.4758L72.2852 43.7745L72.1943 44.0267H72.4614H74.8334H74.9687L75.0114 43.8988L75.5251 42.3836H78.7261L79.2398 43.8988L79.2824 44.0267H79.4178H81.8157H82.0828L81.9919 43.7745L78.6278 34.4758L78.5795 34.3516ZM76.2447 40.2602L77.1237 37.6323L78.0139 40.2602H76.2447Z",
    fill: "url(#paint38_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3672 43.5998C83.8275 43.3791 83.3972 43.0527 83.0764 42.6188C82.7537 42.1867 82.585 41.6655 82.5664 41.0554H84.9773C85.0126 41.4003 85.1312 41.6618 85.3352 41.8436C85.5374 42.0253 85.8026 42.1162 86.1308 42.1162C86.4665 42.1162 86.7317 42.0383 86.9265 41.8844C87.1212 41.7304 87.2176 41.5153 87.2176 41.2427C87.2176 41.0127 87.1397 40.8236 86.9858 40.6734C86.8319 40.5231 86.6409 40.3989 86.4165 40.3024C86.192 40.206 85.8712 40.0947 85.4558 39.9705C84.8549 39.785 84.3653 39.5996 83.9851 39.4141C83.605 39.2287 83.2786 38.9542 83.0041 38.5926C82.7296 38.2309 82.5942 37.758 82.5942 37.1757C82.5942 36.3096 82.9076 35.6327 83.5345 35.1431C84.1613 34.6535 84.9792 34.4087 85.9843 34.4087C87.008 34.4087 87.8352 34.6535 88.462 35.1431C89.0889 35.6327 89.4245 36.3152 89.469 37.1905H87.0192C87.0006 36.8901 86.8912 36.6546 86.6872 36.4821C86.4832 36.3096 86.2236 36.2243 85.9064 36.2243C85.632 36.2243 85.4113 36.2966 85.2444 36.4431C85.0775 36.5896 84.9922 36.7992 84.9922 37.0718C84.9922 37.3723 85.1331 37.6059 85.4168 37.7747C85.6987 37.9416 86.1401 38.1234 86.741 38.3181C87.3419 38.5221 87.8296 38.715 88.2042 38.9004C88.5789 39.0859 88.9034 39.3548 89.1779 39.709C89.4523 40.0614 89.5877 40.5176 89.5877 41.0739C89.5877 41.6043 89.4523 42.0847 89.1834 42.5186C88.9145 42.9507 88.5232 43.2957 88.0114 43.5516C87.4995 43.8075 86.8949 43.9355 86.1976 43.9355C85.5151 43.9318 84.9068 43.8205 84.3672 43.5998Z",
    fill: "url(#paint39_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9849 34.407C87.0086 34.407 87.8358 34.6518 88.4626 35.1414C89.0894 35.631 89.4251 36.3135 89.4696 37.1889H87.0198C87.0012 36.8884 86.8918 36.6529 86.6878 36.4804C86.4838 36.3079 86.2242 36.2226 85.907 36.2226C85.6326 36.2226 85.4119 36.295 85.245 36.4415C85.0781 36.588 84.9927 36.7976 84.9927 37.0702C84.9927 37.3706 85.1337 37.6043 85.4174 37.773C85.6993 37.94 86.1407 38.1217 86.7416 38.3164C87.3425 38.5204 87.8302 38.7133 88.2048 38.8988C88.5794 39.0842 88.904 39.3531 89.1785 39.7073C89.4529 40.0597 89.5883 40.5159 89.5883 41.0723C89.5883 41.6027 89.4529 42.083 89.184 42.517C88.9151 42.9491 88.5238 43.294 88.0119 43.55C87.5001 43.8059 86.8955 43.9339 86.1982 43.9339C85.5176 43.9339 84.9093 43.8244 84.3696 43.6019C83.8299 43.3812 83.3997 43.0548 83.0789 42.6208C82.7562 42.1887 82.5874 41.6676 82.5689 41.0574H84.9798C85.015 41.4024 85.1337 41.6639 85.3377 41.8456C85.5398 42.0274 85.805 42.1182 86.1333 42.1182C86.469 42.1182 86.7342 42.0404 86.9289 41.8864C87.1236 41.7325 87.2201 41.5174 87.2201 41.2448C87.2201 41.0148 87.1422 40.8256 86.9882 40.6754C86.8343 40.5252 86.6433 40.4009 86.4189 40.3045C86.1945 40.2081 85.8737 40.0968 85.4582 39.9725C84.8574 39.7871 84.3678 39.6016 83.9876 39.4162C83.6074 39.2307 83.281 38.9562 83.0065 38.5946C82.732 38.233 82.5967 37.7601 82.5967 37.1777C82.5967 36.3117 82.9101 35.6347 83.5369 35.1451C84.1601 34.6518 84.9779 34.407 85.9849 34.407ZM85.9849 34.2197C84.939 34.2197 84.0766 34.4812 83.4182 34.9949C82.7469 35.5198 82.4057 36.2542 82.4057 37.1759C82.4057 37.7972 82.5559 38.3127 82.8544 38.7059C83.1456 39.0898 83.498 39.3846 83.9023 39.5831C84.2899 39.7722 84.7943 39.9633 85.3989 40.1506C85.8069 40.273 86.124 40.3805 86.341 40.4751C86.5431 40.5623 86.7175 40.6754 86.8547 40.8089C86.9715 40.9239 87.029 41.0649 87.029 41.2429C87.029 41.458 86.9567 41.6194 86.8083 41.7381C86.6489 41.8642 86.4207 41.9291 86.1296 41.9291C85.8477 41.9291 85.6289 41.8549 85.4601 41.7047C85.2913 41.5545 85.1949 41.3375 85.1652 41.037L85.1485 40.8683H84.9798H82.5689H82.376L82.3815 41.0612C82.4001 41.7065 82.5837 42.2685 82.9286 42.7302C83.2699 43.1883 83.7317 43.5388 84.2991 43.7725C84.8574 44.0006 85.4972 44.1175 86.1982 44.1175C86.9215 44.1175 87.5613 43.9821 88.0973 43.7132C88.6388 43.4424 89.0579 43.0715 89.3454 42.6116C89.6328 42.1498 89.7775 41.6305 89.7775 41.0686C89.7775 40.4714 89.6254 39.9744 89.3268 39.5886C89.0357 39.214 88.687 38.9247 88.2883 38.7281C87.9099 38.5408 87.4092 38.3405 86.8009 38.1365C86.2149 37.9474 85.7809 37.7693 85.512 37.6098C85.2858 37.4763 85.1801 37.3038 85.1801 37.0683C85.1801 36.8495 85.2413 36.69 85.3674 36.5806C85.5009 36.4637 85.6771 36.4081 85.907 36.4081C86.1815 36.4081 86.3966 36.4786 86.5673 36.6214C86.7305 36.7605 86.8176 36.9478 86.8325 37.1981L86.8436 37.3743H87.0198H89.4696H89.6681L89.6588 37.1777C89.6124 36.2505 89.2489 35.5161 88.5794 34.9931C87.9192 34.4812 87.0476 34.2197 85.9849 34.2197Z",
    fill: "url(#paint40_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5146 43.5998C91.975 43.3791 91.5447 43.0527 91.2239 42.6188C90.9012 42.1867 90.7324 41.6655 90.7139 41.0554H93.1248C93.16 41.4003 93.2787 41.6618 93.4827 41.8436C93.6849 42.0253 93.9501 42.1162 94.2783 42.1162C94.614 42.1162 94.8792 42.0383 95.0739 41.8844C95.2686 41.7304 95.3651 41.5153 95.3651 41.2427C95.3651 41.0127 95.2872 40.8236 95.1333 40.6734C94.9793 40.5231 94.7883 40.3989 94.5639 40.3024C94.3395 40.206 94.0187 40.0947 93.6033 39.9705C93.0024 39.785 92.5128 39.5996 92.1326 39.4141C91.7524 39.2287 91.426 38.9542 91.1515 38.5926C90.8771 38.2309 90.7417 37.758 90.7417 37.1757C90.7417 36.3096 91.0551 35.6327 91.6819 35.1431C92.3088 34.6535 93.1266 34.4087 94.1318 34.4087C95.1555 34.4087 95.9826 34.6535 96.6095 35.1431C97.2363 35.6327 97.572 36.3152 97.6165 37.1905H95.1666C95.1481 36.8901 95.0387 36.6546 94.8347 36.4821C94.6307 36.3096 94.371 36.2243 94.0539 36.2243C93.7794 36.2243 93.5587 36.2966 93.3918 36.4431C93.2249 36.5896 93.1396 36.7992 93.1396 37.0718C93.1396 37.3723 93.2806 37.6059 93.5643 37.7747C93.8462 37.9416 94.2876 38.1234 94.8885 38.3181C95.4893 38.5221 95.9771 38.715 96.3517 38.9004C96.7263 39.0859 97.0509 39.3548 97.3253 39.709C97.5998 40.0614 97.7352 40.5176 97.7352 41.0739C97.7352 41.6043 97.5998 42.0847 97.3309 42.5186C97.062 42.9507 96.6707 43.2957 96.1588 43.5516C95.647 43.8075 95.0424 43.9355 94.3451 43.9355C93.6626 43.9318 93.0525 43.8205 92.5146 43.5998Z",
    fill: "url(#paint41_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1324 34.407C95.1561 34.407 95.9832 34.6518 96.6101 35.1414C97.2369 35.631 97.5726 36.3135 97.6171 37.1889H95.1672C95.1487 36.8884 95.0393 36.6529 94.8353 36.4804C94.6313 36.3079 94.3716 36.2226 94.0545 36.2226C93.78 36.2226 93.5593 36.295 93.3924 36.4415C93.2255 36.588 93.1402 36.7976 93.1402 37.0702C93.1402 37.3706 93.2811 37.6043 93.5649 37.773C93.8468 37.94 94.2882 38.1217 94.889 38.3164C95.4899 38.5204 95.9777 38.7133 96.3523 38.8988C96.7269 39.0842 97.0514 39.3531 97.3259 39.7073C97.6004 40.0597 97.7358 40.5159 97.7358 41.0723C97.7358 41.6027 97.6004 42.083 97.3315 42.517C97.0626 42.9491 96.6713 43.294 96.1594 43.55C95.6476 43.8059 95.043 43.9339 94.3457 43.9339C93.665 43.9339 93.0568 43.8244 92.5171 43.6019C91.9774 43.3812 91.5471 43.0548 91.2263 42.6208C90.9036 42.1887 90.7349 41.6676 90.7163 41.0574H93.1272C93.1625 41.4024 93.2812 41.6639 93.4852 41.8456C93.6873 42.0274 93.9525 42.1182 94.2808 42.1182C94.6164 42.1182 94.8816 42.0404 95.0764 41.8864C95.2711 41.7325 95.3675 41.5174 95.3675 41.2448C95.3675 41.0148 95.2896 40.8256 95.1357 40.6754C94.9818 40.5252 94.7908 40.4009 94.5663 40.3045C94.3419 40.2081 94.0211 40.0968 93.6057 39.9725C93.0048 39.7871 92.5152 39.6016 92.135 39.4162C91.7549 39.2307 91.4285 38.9562 91.154 38.5946C90.8795 38.233 90.7441 37.7601 90.7441 37.1777C90.7441 36.3117 91.0575 35.6347 91.6844 35.1451C92.3075 34.6518 93.1254 34.407 94.1324 34.407ZM94.1324 34.2197C93.0864 34.2197 92.2241 34.4812 91.5657 34.9949C90.8943 35.5198 90.5531 36.2542 90.5531 37.1759C90.5531 37.7972 90.7033 38.3127 91.0019 38.7059C91.2931 39.0898 91.6454 39.3846 92.0497 39.5831C92.4373 39.7722 92.9418 39.9633 93.5463 40.1506C93.9543 40.273 94.2715 40.3805 94.4885 40.4751C94.6906 40.5623 94.8649 40.6754 95.0022 40.8089C95.119 40.9239 95.1765 41.0649 95.1765 41.2429C95.1765 41.458 95.1042 41.6194 94.9558 41.7381C94.7963 41.8642 94.5682 41.9291 94.277 41.9291C93.9951 41.9291 93.7763 41.8549 93.6076 41.7047C93.4388 41.5545 93.3424 41.3375 93.3127 41.037L93.296 40.8683H93.1272H90.7163H90.5234L90.529 41.0612C90.5475 41.7065 90.7311 42.2685 91.0761 42.7302C91.4173 43.1883 91.8791 43.5388 92.4466 43.7725C93.0048 44.0006 93.6446 44.1175 94.3457 44.1175C95.0689 44.1175 95.7088 43.9821 96.2447 43.7132C96.7862 43.4424 97.2054 43.0715 97.4928 42.6116C97.7803 42.1498 97.9249 41.6305 97.9249 41.0686C97.9249 40.4714 97.7729 39.9744 97.4743 39.5886C97.1831 39.214 96.8345 38.9247 96.4357 38.7281C96.0574 38.5408 95.5567 38.3405 94.9484 38.1365C94.3624 37.9474 93.9284 37.7693 93.6595 37.6098C93.4332 37.4763 93.3275 37.3038 93.3275 37.0683C93.3275 36.8495 93.3887 36.69 93.5148 36.5806C93.6484 36.4637 93.8245 36.4081 94.0545 36.4081C94.329 36.4081 94.5441 36.4786 94.7147 36.6214C94.8779 36.7605 94.9651 36.9478 94.9799 37.1981L94.991 37.3743H95.1672H97.6171H97.8155L97.8062 37.1777C97.7599 36.2505 97.3964 35.5161 96.7269 34.9931C96.0667 34.4812 95.1932 34.2197 94.1324 34.2197Z",
    fill: "url(#paint42_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.391 36.3547V38.2352H104.425V39.984H101.391V42.024H104.822V43.8378H99.127V34.5391H104.822V36.3528H101.391V36.3547Z",
    fill: "url(#paint43_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.822 34.5407V36.3545H101.391V38.235H104.425V39.9838H101.391V42.0238H104.822V43.8376H99.1268V34.5389H104.822M105.009 34.3516H104.822H99.1268H98.9395V34.5389V43.8376V44.0249H99.1268H104.822H105.009V43.8376V42.0238V41.8365H104.822H101.578V40.1711H104.423H104.611V39.9838V38.235V38.0477H104.423H101.578V36.5418H104.822H105.009V36.3545V34.5407V34.3516Z",
    fill: "url(#paint44_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.827 43.5998C107.287 43.3791 106.857 43.0527 106.536 42.6188C106.214 42.1867 106.045 41.6655 106.026 41.0554H108.437C108.473 41.4003 108.591 41.6618 108.795 41.8436C108.997 42.0253 109.263 42.1162 109.591 42.1162C109.926 42.1162 110.192 42.0383 110.386 41.8844C110.581 41.7304 110.678 41.5153 110.678 41.2427C110.678 41.0127 110.6 40.8236 110.446 40.6734C110.292 40.5231 110.101 40.3989 109.876 40.3024C109.652 40.206 109.331 40.0947 108.916 39.9705C108.315 39.785 107.825 39.5996 107.445 39.4141C107.065 39.2287 106.739 38.9542 106.464 38.5926C106.19 38.2309 106.054 37.758 106.054 37.1757C106.054 36.3096 106.368 35.6327 106.994 35.1431C107.621 34.6535 108.439 34.4087 109.444 34.4087C110.468 34.4087 111.295 34.6535 111.922 35.1431C112.549 35.6327 112.884 36.3152 112.929 37.1905H110.475C110.457 36.8901 110.347 36.6546 110.143 36.4821C109.939 36.3096 109.68 36.2243 109.363 36.2243C109.088 36.2243 108.868 36.2966 108.701 36.4431C108.534 36.5896 108.448 36.7992 108.448 37.0718C108.448 37.3723 108.589 37.6059 108.873 37.7747C109.155 37.9416 109.596 38.1234 110.197 38.3181C110.798 38.5221 111.286 38.715 111.66 38.9004C112.035 39.0859 112.36 39.3548 112.634 39.709C112.909 40.0614 113.044 40.5176 113.044 41.0739C113.044 41.6043 112.909 42.0847 112.64 42.5186C112.371 42.9507 111.979 43.2957 111.468 43.5516C110.956 43.8075 110.351 43.9355 109.654 43.9355C108.975 43.9318 108.365 43.8205 107.827 43.5998Z",
    fill: "url(#paint45_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.443 34.407C110.467 34.407 111.294 34.6518 111.921 35.1414C112.547 35.631 112.883 36.3135 112.928 37.1889H110.476C110.457 36.8884 110.348 36.6529 110.144 36.4804C109.94 36.3079 109.68 36.2226 109.363 36.2226C109.089 36.2226 108.868 36.295 108.701 36.4415C108.534 36.588 108.449 36.7976 108.449 37.0702C108.449 37.3706 108.59 37.6043 108.874 37.773C109.155 37.94 109.597 38.1217 110.198 38.3164C110.799 38.5204 111.286 38.7133 111.661 38.8988C112.036 39.0842 112.36 39.3531 112.635 39.7073C112.909 40.0597 113.044 40.5159 113.044 41.0723C113.044 41.6027 112.909 42.083 112.64 42.517C112.371 42.9491 111.98 43.294 111.468 43.55C110.956 43.8059 110.352 43.9339 109.654 43.9339C108.974 43.9339 108.365 43.8244 107.826 43.6019C107.286 43.3812 106.856 43.0548 106.535 42.6208C106.212 42.1887 106.044 41.6676 106.025 41.0574H108.436C108.471 41.4024 108.59 41.6639 108.794 41.8456C108.996 42.0274 109.261 42.1182 109.589 42.1182C109.925 42.1182 110.19 42.0404 110.385 41.8864C110.58 41.7325 110.676 41.5174 110.676 41.2448C110.676 41.0148 110.598 40.8256 110.444 40.6754C110.29 40.5252 110.099 40.4009 109.875 40.3045C109.651 40.2081 109.33 40.0968 108.914 39.9725C108.314 39.7871 107.824 39.6016 107.444 39.4162C107.064 39.2307 106.737 38.9562 106.463 38.5946C106.188 38.233 106.053 37.7601 106.053 37.1777C106.053 36.3117 106.366 35.6347 106.993 35.1451C107.62 34.6518 108.438 34.407 109.443 34.407ZM109.443 34.2197C108.397 34.2197 107.535 34.4812 106.876 34.9949C106.205 35.5198 105.864 36.2542 105.864 37.1759C105.864 37.7972 106.014 38.3127 106.312 38.7059C106.604 39.0898 106.956 39.3846 107.36 39.5831C107.748 39.7722 108.252 39.9633 108.857 40.1506C109.265 40.273 109.582 40.3805 109.799 40.4751C110.001 40.5623 110.175 40.6754 110.313 40.8089C110.43 40.9239 110.487 41.0649 110.487 41.2429C110.487 41.458 110.415 41.6194 110.266 41.7381C110.107 41.8642 109.879 41.9291 109.588 41.9291C109.306 41.9291 109.087 41.8549 108.918 41.7047C108.749 41.5545 108.653 41.3375 108.623 41.037L108.607 40.8683H108.438H106.027H105.834L105.84 41.0612C105.858 41.7065 106.042 42.2685 106.387 42.7302C106.728 43.1883 107.19 43.5388 107.757 43.7725C108.315 44.0006 108.955 44.1175 109.656 44.1175C110.379 44.1175 111.019 43.9821 111.555 43.7132C112.097 43.4424 112.516 43.0715 112.803 42.6116C113.091 42.1498 113.235 41.6305 113.235 41.0686C113.235 40.4714 113.083 39.9744 112.785 39.5886C112.494 39.214 112.145 38.9247 111.746 38.7281C111.368 38.5408 110.867 38.3405 110.259 38.1365C109.673 37.9474 109.239 37.7693 108.97 37.6098C108.744 37.4763 108.638 37.3038 108.638 37.0683C108.638 36.8495 108.699 36.69 108.825 36.5806C108.959 36.4637 109.135 36.4081 109.365 36.4081C109.64 36.4081 109.855 36.4786 110.025 36.6214C110.188 36.7605 110.276 36.9478 110.29 37.1981L110.302 37.3743H110.478H112.928H113.126L113.117 37.1777C113.07 36.2505 112.707 35.5161 112.037 34.9931C111.379 34.4812 110.506 34.2197 109.443 34.2197Z",
    fill: "url(#paint46_radial_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8692 40.658C62.6837 41.0456 62.4204 41.3424 62.081 41.5464C61.7435 41.7485 61.354 41.8487 60.9238 41.8487C60.2246 41.8487 59.659 41.6057 59.2287 41.1198C58.7947 40.6339 58.5778 39.9848 58.5778 39.1744V39.167H56.2744V39.1744C56.2744 40.0906 56.4728 40.9103 56.8697 41.6243C57.2685 42.3401 57.8211 42.8983 58.5333 43.2989C59.2454 43.7014 60.0484 43.9017 60.9497 43.9017C62.055 43.9017 62.999 43.6142 63.7853 43.0356C64.5717 42.457 65.0983 41.6632 65.3636 40.6562H62.8692V40.658Z",
    fill: "url(#paint47_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0134 42.0903V39.1694H66.749V43.8392H71.9807V42.0885H69.0134V42.0903Z",
    fill: "url(#paint48_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1201 39.1694H77.8409L78.2748 40.4472H75.9826L76.411 39.1694H74.1466L72.459 43.8392H74.831L75.3873 42.1961H78.859L79.4154 43.8392H81.8115L80.1201 39.1694Z",
    fill: "url(#paint49_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1769 39.7054C89.0174 39.4977 88.8357 39.3178 88.6391 39.1694H83.5799C83.7078 39.264 83.8395 39.3456 83.9823 39.4142C84.3625 39.5997 84.8539 39.7851 85.4548 39.9706C85.8684 40.093 86.1892 40.2043 86.4136 40.3007C86.6399 40.399 86.829 40.5214 86.9848 40.6716C87.1369 40.8218 87.2148 41.0129 87.2148 41.2428C87.2148 41.5154 87.1165 41.7306 86.9236 41.8845C86.7289 42.0403 86.4637 42.1182 86.128 42.1182C85.8016 42.1182 85.5364 42.0273 85.3343 41.8455C85.1321 41.6657 85.0116 41.4023 84.9763 41.0592H82.5654C82.5858 41.6675 82.7527 42.1886 83.0754 42.6226C83.3981 43.0566 83.8284 43.3811 84.3681 43.6018C84.9059 43.8244 85.5142 43.9356 86.1966 43.9356C86.8921 43.9356 87.4985 43.8077 88.0104 43.5499C88.5241 43.294 88.9135 42.949 89.1843 42.5187C89.4514 42.0848 89.5868 41.6045 89.5868 41.0741C89.5886 40.514 89.4495 40.0578 89.1769 39.7054Z",
    fill: "url(#paint50_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3225 39.7054C97.163 39.4977 96.9813 39.3178 96.7847 39.1694H91.7255C91.8534 39.264 91.9851 39.3456 92.1279 39.4142C92.5081 39.5997 92.9995 39.7851 93.6004 39.9706C94.014 40.093 94.3348 40.2043 94.5592 40.3007C94.7855 40.399 94.9746 40.5214 95.1304 40.6716C95.2825 40.8218 95.3604 41.0129 95.3604 41.2428C95.3604 41.5154 95.2621 41.7306 95.0692 41.8845C94.8745 42.0403 94.6093 42.1182 94.2736 42.1182C93.9472 42.1182 93.682 42.0273 93.4799 41.8455C93.2777 41.6657 93.1572 41.4023 93.1219 41.0592H90.7129C90.7296 41.6675 90.8983 42.1886 91.221 42.6226C91.5437 43.0566 91.974 43.3811 92.5137 43.6018C93.0515 43.8244 93.6598 43.9356 94.3422 43.9356C95.0377 43.9356 95.6441 43.8077 96.156 43.5499C96.6697 43.294 97.0592 42.949 97.3299 42.5187C97.597 42.0848 97.7324 41.6045 97.7324 41.0741C97.7324 40.514 97.5951 40.0578 97.3225 39.7054Z",
    fill: "url(#paint51_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.391 42.023V39.9811H104.423V39.167H99.125V43.8367H104.822V42.0211H101.391V42.023Z",
    fill: "url(#paint52_linear_5_6445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.634 39.7054C112.475 39.4977 112.293 39.3197 112.098 39.1694H107.037C107.165 39.264 107.301 39.3456 107.443 39.4142C107.824 39.5997 108.313 39.7851 108.914 39.9706C109.33 40.093 109.65 40.2043 109.877 40.3007C110.099 40.399 110.29 40.5214 110.446 40.6716C110.602 40.8218 110.68 41.0129 110.68 41.2428C110.68 41.5154 110.581 41.7306 110.387 41.8845C110.194 42.0403 109.929 42.1182 109.593 42.1182C109.265 42.1182 108.999 42.0273 108.797 41.8455C108.595 41.6657 108.476 41.4023 108.441 41.0592H106.03C106.047 41.6675 106.218 42.1886 106.54 42.6226C106.861 43.0566 107.291 43.3811 107.829 43.6018C108.367 43.8244 108.979 43.9356 109.658 43.9356C110.357 43.9356 110.96 43.8077 111.473 43.5499C111.983 43.294 112.375 42.949 112.645 42.5187C112.916 42.0848 113.048 41.6045 113.048 41.0741C113.046 40.514 112.911 40.0578 112.634 39.7054Z",
    fill: "url(#paint53_linear_5_6445)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_6445",
    x: 0.807617,
    y: 0.657227,
    width: 117.428,
    height: 58.8838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_6445"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_6445",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_6445",
    x1: 41.7113,
    y1: 18.48,
    x2: 48.625,
    y2: 10.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_6445",
    x1: 36.6784,
    y1: 18.2597,
    x2: 55.2142,
    y2: 4.7304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_6445",
    x1: 36.6784,
    y1: 18.2597,
    x2: 55.2142,
    y2: 4.7304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    stopColor: "#F9FCFE",
    stopOpacity: 0.2444
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    stopColor: "#E8F3FB",
    stopOpacity: 0.6141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#CFE6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_6445",
    x1: 18.5082,
    y1: 18.9714,
    x2: 44.2557,
    y2: 16.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0136 15.8627) scale(3.02076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_6445",
    x1: 7.70836,
    y1: 6.34239,
    x2: 48.8328,
    y2: 37.3645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A56A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9475 17.4992) scale(5.52405 5.52405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2207 8.12726) scale(4.47004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1965,
    stopColor: "#D11217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#C71418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5002,
    stopColor: "#B8161A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6375,
    stopColor: "#A3171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7694,
    stopColor: "#8A171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#6D1518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_6445",
    x1: 33.5447,
    y1: 43.0669,
    x2: 36.6434,
    y2: 53.1654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_6445",
    x1: 36.402,
    y1: 38.9191,
    x2: 38.0293,
    y2: 61.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5_6445",
    x1: 36.402,
    y1: 38.9191,
    x2: 38.0293,
    y2: 61.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    stopColor: "#F9FCFE",
    stopOpacity: 0.2444
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    stopColor: "#E8F3FB",
    stopOpacity: 0.6141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#CFE6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5_6445",
    x1: 45.4435,
    y1: 23.1418,
    x2: 34.1255,
    y2: 46.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6029 44.7128) rotate(122.059) scale(3.02079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5_6445",
    x1: 61.8788,
    y1: 20.6922,
    x2: 13.7587,
    y2: 39.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A56A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.6942 31.9213) scale(5.52229 5.52229)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7621 43.0615) rotate(122.059) scale(4.47005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    stopColor: "#F3B109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3896,
    stopColor: "#EEA80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5489,
    stopColor: "#E59812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6996,
    stopColor: "#D98315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#CB6817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9822,
    stopColor: "#BB4717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B84217"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5_6445",
    x1: 16.1327,
    y1: 24.1348,
    x2: 5.78471,
    y2: 22.0116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5_6445",
    x1: 18.4025,
    y1: 28.6311,
    x2: -2.46553,
    y2: 19.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5_6445",
    x1: 18.4025,
    y1: 28.6311,
    x2: -2.46553,
    y2: 19.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    stopColor: "#F9FCFE",
    stopOpacity: 0.2444
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    stopColor: "#E8F3FB",
    stopOpacity: 0.6141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#CFE6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5_6445",
    x1: 27.9126,
    y1: 44.1317,
    x2: 12.8997,
    y2: 23.0306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7016 25.1507) rotate(-119.287) scale(3.02082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5_6445",
    x1: 22.1807,
    y1: 59.7297,
    x2: 29.1201,
    y2: 8.68498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A56A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9672 36.6404) scale(5.51085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.2795 34.8595) rotate(-119.287) scale(4.47015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FB130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    stopColor: "#5CAE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#54A430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5891,
    stopColor: "#479330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7509,
    stopColor: "#377D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9046,
    stopColor: "#24642A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5_6445",
    x1: 67.6625,
    y1: -0.179425,
    x2: 67.6625,
    y2: 25.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.6626 22.0965) scale(10.3402)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5_6445",
    x1: 87.1333,
    y1: -0.179425,
    x2: 87.1333,
    y2: 25.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.1337 22.0965) scale(9.10598 9.10598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5_6445",
    x1: 67.6612,
    y1: 15.6239,
    x2: 67.6612,
    y2: 30.7408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5_6445",
    x1: 87.1313,
    y1: 15.6239,
    x2: 87.1313,
    y2: 30.7408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5_6445",
    x1: 104.466,
    y1: -0.179425,
    x2: 104.466,
    y2: 25.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.465 22.0965) scale(9.10598 9.10598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5_6445",
    x1: 104.464,
    y1: 15.6239,
    x2: 104.464,
    y2: 30.7408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5_6445",
    x1: 60.8156,
    y1: 28.6529,
    x2: 60.8156,
    y2: 40.7087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.8433 39.1695) scale(4.84212)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5_6445",
    x1: 69.3674,
    y1: 28.6531,
    x2: 69.3674,
    y2: 40.7089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.3672 39.1897) scale(3.95364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5_6445",
    x1: 77.1361,
    y1: 28.6531,
    x2: 77.1361,
    y2: 40.7089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.1357 39.1897) scale(4.89083 4.89083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5_6445",
    x1: 86.0766,
    y1: 28.653,
    x2: 86.0766,
    y2: 40.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.0745 39.1696) scale(4.37028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5_6445",
    x1: 94.2237,
    y1: 28.653,
    x2: 94.2237,
    y2: 40.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.2215 39.1696) scale(4.37028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5_6445",
    x1: 101.974,
    y1: 28.6535,
    x2: 101.974,
    y2: 40.7093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.973 39.1897) scale(4.03833 4.03834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5_6445",
    x1: 109.536,
    y1: 28.653,
    x2: 109.536,
    y2: 40.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_5_6445",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.534 39.1696) scale(4.37028 4.37028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5_6445",
    x1: 60.8162,
    y1: 36.1272,
    x2: 60.8162,
    y2: 43.2774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5_6445",
    x1: 69.3661,
    y1: 36.1278,
    x2: 69.3661,
    y2: 43.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5_6445",
    x1: 77.1356,
    y1: 36.1278,
    x2: 77.1356,
    y2: 43.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5_6445",
    x1: 86.0771,
    y1: 36.1278,
    x2: 86.0771,
    y2: 43.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5_6445",
    x1: 94.2235,
    y1: 36.1278,
    x2: 94.2235,
    y2: 43.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5_6445",
    x1: 101.974,
    y1: 36.1272,
    x2: 101.974,
    y2: 43.2774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5_6445",
    x1: 109.536,
    y1: 36.1278,
    x2: 109.536,
    y2: 43.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityLogo);
export default __webpack_public_path__ + "static/media/CommunityLogo.62f7992f4830be38fa50c455ba375c99.svg";
export { ForwardRef as ReactComponent };